import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import OnsaMarket from '../pages/OnsaMarket';
import FriendReferralsPage from '../pages/FriendReferralsPage';

const DashboardPage = lazy(() => import('../pages/Dashboard/DashboardPage'));
const OnsaStockPage = lazy(() => import('../pages/OnsaStockPage'));
const PromotionsPage = lazy(() => import('../pages/PromotionsPage'));
const CompetitionPage = lazy(() => import('../pages/CompetitionPage'));
const OfferRequestPage = lazy(() => import('../pages/OfferRequestPage'));
const TrendsPreview = lazy(() => import('../pages/TrendsPreview'));
const NewsPreview = lazy(() => import('../pages/NewsPreview'));
const MarketsCharts = lazy(() => import('../pages/MarketsCharts'));
const EconomicCalendar = lazy(() => import('../pages/EconomicCalendar'));
const ClientBoostsPage = lazy(() => import('../pages/ClientBoostsPage'));
const AnnouncementDetailPage = lazy(() => import('../pages/AnnouncementDetailPage'));
const TradeAIPage = lazy(() => import('../pages/TradeAIPage'));
const InvestorCategoriesPage = lazy(() => import('../pages/InvestorCategories'));
const FeedbackSupportPage = lazy(() => import('../pages/FeedbackSupportPage'));
const FeedbackSupportThreadPage = lazy(() => import('../pages/FeedbackSupportThreadPage'));
const HowToUsePage = lazy(() => import('../pages/HowToUsePage'));
const AnnouncementsPage = lazy(() => import('../pages/AnnouncementsPage'));

const AppRoutes = () => (
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/friend-referrals" element={<FriendReferralsPage />} />
      <Route path="/onsa-stock" element={<OnsaStockPage />} />
      <Route path="/promotions" element={<PromotionsPage />} />
      <Route path="/competition" element={<CompetitionPage />} />
      <Route path="/offer-request" element={<OfferRequestPage />} />
      <Route path="/trends" element={<TrendsPreview />} />
      <Route path="/trade-ai" element={<TradeAIPage />} />
      <Route path="/news" element={<NewsPreview />} />
      <Route path="/markets" element={<MarketsCharts />} />
      <Route path="/calendar" element={<EconomicCalendar />} />
      <Route path="/onsa-market" element={<OnsaMarket />} />
      <Route path="/client-boosts" element={<ClientBoostsPage />} />
      <Route path="/feedback-support" element={<FeedbackSupportPage />} />
      <Route path="/feedback-support/:threadId" element={<FeedbackSupportThreadPage />} />
      <Route path="/investor-categories" element={<InvestorCategoriesPage />} />
      <Route path="/investor-categories/:categoryId" element={<InvestorCategoriesPage />} />
      <Route path="/how-to-use" element={<HowToUsePage />} />
      <Route path="/announcements" element={<AnnouncementsPage />} />
      <Route path="/announcements/:slug" element={<AnnouncementDetailPage />} />
    </Routes>
);

export default AppRoutes;
